import React, { useContext } from 'react';
import '../css/newsEvents.css';
import truncateWords from '../../../../format/truncateWords';
import { useNavigate } from 'react-router-dom';
import { Store } from '../../../../Store';

const NewsEvents = ({ data }) => {
  const navigate = useNavigate();

  const { dispatch: ctxDispatch } = useContext(Store);
  const saveBreadcrumb = (title, slug, url) => {
    const breadcrumb = [
      {
        title: 'Tin tức',
        slug: '/tin-tuc',
      },
      {
        title,
        slug,
      },
    ];
    ctxDispatch({
      type: 'SET_BREADCRUMB',
      payload: breadcrumb,
    });
    localStorage.setItem('resentBread', JSON.stringify(breadcrumb));
    navigate(url);
  };

  const getTopicSlug = (post) => {
    const { topics } = post;
    return topics[0].slug;
  };
  return (
    <section className="media-talking-about-us">
      <div className="container">
        <h2 className="text-center default-box-title ">TIN TỨC & Sự kiện</h2>
        {data.map((content, idx) => (
          <div key={idx} className="bg-layer my-md-5 my-4 px-xl-4 px-3">
            <div className="box-wrap">
              <div className="items">
                {content.data.map((item, index) => (
                  <div key={index} className="item-wrap bg-white shadow-sm p-3">
                    <div className="text-center mb-3">
                      <div
                        className="a"
                        style={{
                          display: 'block',
                          width: '100%',
                          overflow: 'hidden',
                          cursor: ' pointer',
                        }}
                        onClick={() =>
                          saveBreadcrumb(
                            content.title,
                            content.slug,
                            `/${getTopicSlug(item)}/${item.slug}`
                          )
                        }
                      >
                        <img
                          data-src={item.thumbnail}
                          className=" thumbnail owl-lazy zoom-image"
                          alt={item.title}
                          loading="lazy"
                          src={item.thumbnail}
                          style={{
                            width: '100%',
                            aspectRatio: '3/2',
                            objectFit: 'cover',
                            opacity: '1',
                            transition: 'transform 0.3s ease',
                          }}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <h3 className="mb-3">
                        <div
                          style={{ cursor: 'pointer' }}
                          onClick={() =>
                            saveBreadcrumb(
                              content.title,
                              content.slug,
                              `/${getTopicSlug(item)}/${item.slug}`
                            )
                          }
                        >
                          {truncateWords(item.title, 12)}
                        </div>
                      </h3>
                      <p>{truncateWords(item.short_description, 20)}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-center more">
                <div
                  onClick={() =>
                    saveBreadcrumb(
                      content.title,
                      content.slug,
                      `/chuyen-di-tham-thay-co`
                    )
                  }
                  className="btn"
                >
                  <img
                    src="/images/icons/list-icon-white.png"
                    className="mw-100 me-2"
                    alt=""
                    loading="lazy"
                  />
                  Xem tất cả
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default NewsEvents;
